// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import * as Setting from "../../conf/Setting";
import {Dropdown, Menu} from "antd";
import "../../App.less";
import moment from "moment";
import IconSymbol from "../common/IconSymbol";

class SelectLanguageBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
    };
  }

  render() {
    const iconStyle = {width: "1em", height: "1em"};
    const menu = (
      <Menu onClick={(e) => {
        Setting.changeLanguage(e.key);
        if (e.key === "zh") {
          moment.locale("zh-cn");
        } else {
          moment.locale("en_GB");
        }
      }}>
        <Menu.Item key="zh" icon={<IconSymbol name="icon-zh" style={iconStyle} />}>简体中文</Menu.Item>
        <Menu.Item key="en" icon={<IconSymbol name="icon-en" style={iconStyle} />}>English</Menu.Item>
        {/* <Menu.Item key="fr" icon={<IconSymbol name="icon-fr" style={iconStyle} />}>Français</Menu.Item>
        <Menu.Item key="de" icon={<IconSymbol name="icon-de" style={iconStyle} />}>Deutsch</Menu.Item>
        <Menu.Item key="ja" icon={<IconSymbol name="icon-ja" style={iconStyle} />}>日本語</Menu.Item>
        <Menu.Item key="ko" icon={<IconSymbol name="icon-ko" style={iconStyle} />}>한국어</Menu.Item>
        <Menu.Item key="ru" icon={<IconSymbol name="icon-ru" style={iconStyle} />}>Русский</Menu.Item> */}
      </Menu>
    );

    return (
      <Dropdown overlay={menu} >
        {this.props.menuBtn ? this.props.menuBtn : <div className={this.props.isWhite ? "language-box-white" : "language-box"} id={this.props.id} style={this.props.style} />}
      </Dropdown>
    );
  }
}

export default SelectLanguageBox;
